// Demo site (Try Teamio) — what a demo session does not see (plan Task 6.5: design 2d "hidden" row + decision 4a).
// Pure and import-free: cypress/node-tests/demo-hidden.test.js executes this file. Every answer is "allowed" unless
// the flag is exactly `true`, so a real practice is never affected.

// Route NAMES (src/Routes.js) a demo session may not open: the dev pages, Workflow v1, Checklists + Routines (dead
// legacy, no backend), the A2P wizard page, the site picker, and the Super Admin page (already role-gated).
export const DEMO_HIDDEN_ROUTE_NAMES = Object.freeze([
  'TaskManager', 'Test', 'VideoTest',
  'Workflow', 'ViewWorkflow', 'CreateWorkflow', 'WorkflowOutput',
  'Checklists', 'CreateChecklist', 'ViewChecklist', 'Routine', 'createroutine', 'ViewRoutine',
  'A2PRegistration', 'SelectSite', 'super-admin',
]);

/** Is this route (a vue-router Route: its name or any matched record's name) closed to a demo session? */
export function isRouteHiddenInDemo(route, isDemo) {
  if (isDemo !== true || !route) return false;
  const names = [route.name].concat((route.matched || []).map(r => r && r.name));
  return names.some(n => typeof n === 'string' && DEMO_HIDDEN_ROUTE_NAMES.indexOf(n) !== -1);
}

const FALLBACK_PATH = '/app/todo';

// The /app/<segment> paths of the hidden pages (src/Routes.js), for vetting a stored landing path.
const HIDDEN_APP_SEGMENTS = ['task2', 'test', 'video-test', 'workflow', 'create-workflow', 'workflow-output',
  'checklists', 'create-checklist', 'view-checklist', 'routine', 'createroutine', 'viewroutine', 'Gautam'];

/**
 * Where a demo session goes instead of a hidden page: nowhere (stay on the current page) when there is one, else its
 * landing page (localStorage redirectPath: an in-app path, never a hidden page), else /app/todo.
 */
export function demoHiddenRedirect(from, redirectPath) {
  if (from && Array.isArray(from.matched) && from.matched.length > 0) return false;
  if (typeof redirectPath !== 'string' || redirectPath.indexOf('/app/') !== 0) return FALLBACK_PATH;
  const segment = redirectPath.slice('/app/'.length).split(/[/?#]/)[0];
  if (HIDDEN_APP_SEGMENTS.indexOf(segment) !== -1 || redirectPath.indexOf('/app/my-account/a2p') === 0) return FALLBACK_PATH;
  return redirectPath;
}

/** May a control that is closed to the demo show? True for everyone except a demo session. */
export function demoAllows(isDemo) {
  return isDemo !== true;
}
